import { render, staticRenderFns } from "./Expert2RealEstateEdit.vue?vue&type=template&id=662a6348&scoped=true&"
import script from "./Expert2RealEstateEdit.vue?vue&type=script&lang=js&"
export * from "./Expert2RealEstateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662a6348",
  null
  
)

export default component.exports